import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "contexts";
import { ExceptionHandlingType } from "types/apiServiceTypes";

export type SuspiciousLoginUser = {
  userId: string;
  login: string;
  createdAt: Date;
  profileImageUrl: string | null;
  displayName: string;
  email: string;
  isBanned: boolean;
  banReason: string | null;
  loginsCount: number;
  lastUserAgent: string;
  lastLoginAt: Date;
};

export type SuspiciousLoginsDetailData = SuspiciousLoginUser[];

export const useSuspiciousLoginsDetailQuery = (ip: string | null) => {
  const { accessFetch } = useAppContext();

  return useQuery<SuspiciousLoginsDetailData>({
    queryKey: ["suspicious-logins-detail", ip],
    queryFn: async () => {
      try {
        const response = await accessFetch(
          `/user-login/suspicious-logins/${ip}`,
          {
            method: "GET",
          },
          ExceptionHandlingType.AUTOMATIC
        );

        const data = await response?.json();

        if (!response?.ok) {
          return Promise.reject({
            uniqueUsersCount: 0,
            totalLoginsCount: 0,
            sameUserAgentsCount: 0,
            suspicionScore: 0,
            users: [],
          });
        }

        return data;
      } catch (error) {
        console.error("Error fetching suspicious logins detail:", error);
        return {
          uniqueUsersCount: 0,
          totalLoginsCount: 0,
          sameUserAgentsCount: 0,
          suspicionScore: 0,
          users: [],
        };
      }
    },
    initialData: [],
    enabled: !!ip,
  });
};
